import { render, staticRenderFns } from "./MarketAnnouncements.vue?vue&type=template&id=71aa16d2"
import script from "./MarketAnnouncements.vue?vue&type=script&lang=js"
export * from "./MarketAnnouncements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoaderAnimation: require('/vercel/path0/components/ui/LoaderAnimation.vue').default,InfoBox: require('/vercel/path0/components/InfoBox.vue').default,MarketAnnouncementCard: require('/vercel/path0/components/MarketAnnouncementCard.vue').default,BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default})
